import React from "react";
import { PackageSearch } from "lucide-react";
import type { BackendOrder } from "./types";
import OrderCard from "./OrderCard";

interface OrdersListProps {
  orders: BackendOrder[];
  filteredOrders: BackendOrder[];
  loading: boolean;
}

const OrdersList: React.FC<OrdersListProps> = ({
  orders,
  filteredOrders,
  loading,
}) => {
  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center py-24 bg-section-card-bg">
        <div className="animate-spin rounded-full h-12 w-12 border-4 border-primary border-t-transparent mb-4"></div>
        <span className="text-section-muted font-medium">Loading orders...</span>
      </div>
    );
  }

  if (filteredOrders.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-24 px-4 bg-section-card-bg text-center">
        <div className="relative inline-block mb-6">
          <div className="absolute inset-0 bg-primary/20 rounded-full blur-xl opacity-30"></div>
          <PackageSearch
            className="relative w-20 h-20 text-section-muted"
            strokeWidth={1.5}
          />
        </div>
        <h3 className="text-xl font-bold text-section-text mb-2">No orders found</h3>
        <p className="text-section-muted max-w-sm mx-auto leading-relaxed">
          {orders.length === 0
            ? "You haven't placed any orders yet. Start shopping to fill this list!"
            : `No orders match your search. Try adjusting your filters.`}
        </p>
      </div>
    );
  }

  return (
    <div className="divide-y divide-section-border bg-section-card-bg">
      {filteredOrders.map((order) => (
        <OrderCard key={order.id} order={order} />
      ))}
    </div>
  );
};

export default OrdersList;
